// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".items-layer[data-v-611ad27e]{top:8.375rem;bottom:0;left:100%;overflow:scroll;transition:left .3s ease}.items-layer.is-open[data-v-611ad27e]{left:0}", ""]);
// Exports
module.exports = exports;
